import { useCallback, useContext, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { useLanguage } from 'assets/languages';
import { ROUTES } from 'routes';
import { queries } from 'api/api.constants';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import CampaignFormStepOne from '../campaignFormStepOne/campaignFormStepOne';
import CampaignFormStepThree from '../campaignFormStepThree/campaignFormStepThree';
import CampaignFormStepTwo from '../campaignFormStepTwo/campaignFormStepTwo';
import { CAMPAIGN_UPDATE_FORM_TYPE } from 'constants/campaign';

/**
 * TODO: isMaster 관련 로직은 추후 Manage에서 수정 기능 생기면 코드 정리 필요
 */
const UpdateCampaignForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };
  const { modal, auth, updateCampaignId, step, setStep, initializeCampaignFormData, setShowLoader } =
    useContext(CampaignFormContext);

  const isMasterUpdateForm = useMemo(() => {
    return location?.search?.includes(CAMPAIGN_UPDATE_FORM_TYPE.MASTER);
  }, [location?.search]);

  // 캠페인 조회
  const { data: campaign, error: campaignError } = useQuery({
    ...queries.campaign.getCampaign({
      brandToken: auth.token,
      campaignId: updateCampaignId,
    }),
    enabled: !!auth.token && !!updateCampaignId,
    select: (data) => data.data.campaign,
  });

  const errorModal = useCallback((message: string) => {
    modal.showModal({
      text: message,
      preventCloseWithBackgroundDimmer: true,
      hideCloseButton: true,
      confirm: () => navigate(ROUTES.CAMPAIGN_INDEX.PATH, { replace: true }),
    });
  }, []);

  // 캠페인 조회 성공 후 데이터 처리
  useEffect(() => {
    if (campaign) {
      // 캠페인 모집 시작일이 지난 경우
      if (dayjs().isAfter(campaign.recruitStartsAt)) {
        // 마스터인 경우 2단계로 이동
        if (isMasterUpdateForm) {
          setStep(2);
        } else {
          errorModal(languageTexts.campaign_form_is_after_recruit_start);
          return;
        }
      }

      initializeCampaignFormData({ loadedCampaign: campaign });
      setShowLoader(false);
    }
  }, [campaign]);

  // 캠페인 조회 실패 후 데이터 처리
  useEffect(() => {
    if (campaignError) {
      errorModal((campaignError as Error)?.message);
    }
  }, [campaignError]);

  return (
    <>
      {!isMasterUpdateForm && step === 1 && <CampaignFormStepOne />}
      {step === 2 && <CampaignFormStepTwo />}
      {step === 3 && <CampaignFormStepThree />}
    </>
  );
};

export default UpdateCampaignForm;
